import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  CONFIRM_PASSWORD_INFO,
  CONFIRM_PASSWORD_INFO_PS,
  CONFIRM_PASSWORD_TITLE,
  CONFIRM_PASSWORD_TITLE_JUST_PURCHASED,
} from '../../config/text/text';
import { showConfirmEmailModal } from '../../helpers/user';
import WowModal from '../WowModal';
import Tile from '../_generic/tile/Tile';
import TileBody from '../_generic/tile/TileBody';
import ActivateList from '../password/ActivateList';

const PasswordConfirmEmailModal = ({ hasJustPurchased = false }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const userEmail = useSelector((state) => state.user.userprofile.email);
  const [showModal, setShowModal] = useState(false);
  const modalTitle = hasJustPurchased
    ? CONFIRM_PASSWORD_TITLE_JUST_PURCHASED
    : CONFIRM_PASSWORD_TITLE;

  useEffect(() => {
    let isMounted = true;
    async function checkShowModal() {
      if (isAuthenticated && userEmail) {
        const isShowModal = await showConfirmEmailModal(
          isAuthenticated,
          userEmail,
        );
        if (isMounted) setShowModal(isShowModal);
      }
    }
    checkShowModal();

    return () => {
      isMounted = false;
    };
  }, [isAuthenticated, userEmail]);

  return (
    <>
      <WowModal
        ariaLabelledBy=""
        backdrop="static"
        centered
        extraClasses="pw-activate"
        keyboard={false}
        setShowModal={setShowModal}
        showCloseButton={false}
        showHeader={false}
        showModal={showModal}
        size="md"
      >
        <Tile title={modalTitle}>
          <TileBody nopadding>
            <p className="info">{CONFIRM_PASSWORD_INFO}</p>
            <ActivateList />
            <p>{CONFIRM_PASSWORD_INFO_PS}</p>
          </TileBody>
        </Tile>
      </WowModal>
    </>
  );
};

PasswordConfirmEmailModal.propTypes = {
  hasJustPurchased: PropTypes.bool,
};

export default PasswordConfirmEmailModal;
